module.exports = __webpack_public_path__ + "img/navNotification.37952051.svg";